/*
 * DO NOT EDIT
 * ===========
 * This file was auto-generated.
 * To update run the TypeScript Code Generator in the API.
 */

export enum ReportRequestStatus {
  Pending = 0,
  InProgress = 1,
  Complete = 2,
  Failed = 3,
}
